package qrcode

import auth.CurrentWorkspaceStore
import com.jillesvangurp.geojson.urlEncode
import apiclient.geoobjects.MarkerColor
import apiclient.geoobjects.MarkerIcon
import apiclient.geoobjects.MarkerShape
import dev.fritz2.core.RootStore
import dev.fritz2.core.storeOf
import dev.fritz2.remote.btoa
import io.ktor.util.*
import io.ktor.utils.io.core.*
import koin.koinCtx
import kotlinx.browser.document
import kotlinx.browser.window
import kotlinx.coroutines.Job
import kotlinx.coroutines.coroutineScope
import kotlinx.coroutines.delay
import kotlinx.coroutines.launch
import org.w3c.dom.HTMLIFrameElement
import org.w3c.dom.events.MouseEvent
import overlays.BusyStore
import qrcodegeneration.urlToSvgQrCode

const val defaultCharacters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890"

val logo =
    """
<svg viewBox="0 0 199.98 244.84"><g id="Layer_2" data-name="Layer 2"><g id="logos"><circle cx="36.69" cy="4" r="4"/><circle cx="48.52" cy="23.65" r="4"/><circle cx="60.34" cy="23.65" r="4"/><circle cx="72.16" cy="23.65" r="4"/><circle cx="83.99" cy="23.65" r="4"/><circle cx="95.81" cy="23.65" r="4"/><circle cx="119.12" cy="6.26" r="4"/><circle cx="119.46" cy="23.65" r="4"/><circle cx="36.69" cy="34.43" r="4"/><circle cx="48.52" cy="34.43" r="4"/><circle cx="60.34" cy="34.43" r="4"/><circle cx="72.16" cy="34.43" r="4"/><circle cx="83.99" cy="34.43" r="4"/><circle cx="95.81" cy="34.43" r="4"/><circle cx="107.64" cy="34.43" r="4"/><circle cx="119.46" cy="34.43" r="4"/><circle cx="36.69" cy="45.21" r="4"/><circle cx="48.52" cy="45.21" r="4"/><circle cx="60.34" cy="45.21" r="4"/><circle cx="72.16" cy="45.21" r="4"/><circle cx="83.99" cy="45.21" r="4"/><circle cx="95.81" cy="45.21" r="4"/><circle cx="107.64" cy="45.21" r="4"/><circle cx="119.46" cy="45.21" r="4"/><circle cx="15.13" cy="66.43" r="4"/><circle cx="48.52" cy="55.99" r="4"/><circle cx="60.34" cy="55.99" r="4"/><circle cx="36.69" cy="66.77" r="4"/><circle cx="48.52" cy="66.77" r="4"/><circle cx="60.34" cy="66.77" r="4"/><circle cx="36.69" cy="77.56" r="4"/><circle cx="48.52" cy="77.56" r="4"/><circle cx="60.34" cy="77.56" r="4"/><circle cx="25.91" cy="98.77" r="4"/><circle cx="48.52" cy="88.34" r="4"/><circle cx="60.34" cy="88.34" r="4"/><circle cx="36.69" cy="99.12" r="4"/><circle cx="48.52" cy="99.12" r="4"/><circle cx="60.34" cy="99.12" r="4"/><circle cx="30.43" cy="240.84" r="4"/><circle cx="131.98" cy="23.65" r="4"/><circle cx="143.81" cy="23.65" r="4"/><circle cx="155.63" cy="45.39" r="4"/><circle cx="179.46" cy="15.48" r="4"/><circle cx="131.98" cy="34.43" r="4"/><circle cx="143.81" cy="34.43" r="4"/><circle cx="155.63" cy="34.43" r="4"/><circle cx="195.98" cy="34.43" r="4"/><circle cx="131.98" cy="45.21" r="4"/><circle cx="119.64" cy="66.95" r="4"/><circle cx="167.46" cy="45.21" r="4"/><circle cx="36.69" cy="110.77" r="4"/><circle cx="48.52" cy="110.77" r="4"/><circle cx="60.34" cy="110.77" r="4"/><circle cx="72.16" cy="99.99" r="4"/><circle cx="83.99" cy="99.99" r="4"/><circle cx="25.91" cy="23.65" r="4"/><circle cx="107.64" cy="99.99" r="4"/><circle cx="119.46" cy="99.99" r="4"/><circle cx="36.69" cy="121.55" r="4"/><circle cx="48.52" cy="121.55" r="4"/><circle cx="60.34" cy="121.55" r="4"/><circle cx="72.16" cy="110.77" r="4"/><circle cx="83.99" cy="110.77" r="4"/><circle cx="95.81" cy="110.77" r="4"/><circle cx="107.64" cy="110.77" r="4"/><circle cx="119.46" cy="110.77" r="4"/><circle cx="6.61" cy="152.85" r="4"/><circle cx="48.52" cy="132.33" r="4"/><circle cx="60.34" cy="132.33" r="4"/><circle cx="72.16" cy="121.55" r="4"/><circle cx="83.99" cy="121.55" r="4"/><circle cx="95.81" cy="121.55" r="4"/><circle cx="107.64" cy="121.55" r="4"/><circle cx="119.46" cy="142.94" r="4"/><circle cx="36.69" cy="143.11" r="4"/><circle cx="48.52" cy="143.11" r="4"/><circle cx="60.34" cy="143.11" r="4"/><circle cx="36.69" cy="153.89" r="4"/><circle cx="48.52" cy="153.89" r="4"/><circle cx="48.52" cy="164.68" r="4"/><circle cx="59.99" cy="164.68" r="4"/><circle cx="83.29" cy="154.42" r="4"/><circle cx="36.69" cy="175.46" r="4"/><circle cx="48.52" cy="175.46" r="4"/><circle cx="60.34" cy="175.46" r="4"/><circle cx="26.26" cy="175.28" r="4"/><circle cx="48.52" cy="186.24" r="4"/><circle cx="36.69" cy="186.24" r="4"/><circle cx="60.34" cy="186.24" r="4"/><circle cx="131.98" cy="99.99" r="4"/><circle cx="143.81" cy="99.99" r="4"/><circle cx="155.63" cy="99.99" r="4"/><circle cx="194.06" cy="88.86" r="4"/><circle cx="131.98" cy="110.77" r="4"/><circle cx="143.81" cy="110.77" r="4"/><circle cx="155.63" cy="110.77" r="4"/><circle cx="179.8" cy="110.77" r="4"/><circle cx="131.98" cy="121.55" r="4"/><circle cx="143.81" cy="121.55" r="4"/><circle cx="36.69" cy="197.71" r="4"/><circle cx="48.52" cy="197.71" r="4"/><circle cx="60.34" cy="197.71" r="4"/><circle cx="36.69" cy="208.5" r="4"/><circle cx="48.52" cy="208.5" r="4"/><circle cx="60.34" cy="229.54" r="4"/><circle cx="13.39" cy="218.23" r="4"/><circle cx="4" cy="45.04" r="4"/><circle cx="79.12" cy="206.76" r="4"/></g></g></svg>
"""
        .trimIndent()

fun randomCode(length: Int = 10, charPool: String = defaultCharacters): String {
    return (1.rangeTo(length))
        .map { kotlin.random.Random.nextInt(0, charPool.length) }
        .map(charPool::get)
        .joinToString("")
}

data class CodeData(
    val code: String,
    val link: String,
    val color: MarkerColor? = null,
    val shape: MarkerShape? = null,
    val icon: MarkerIcon? = null,
    val tag: String? = null,
    val token: String? = null,
)

fun CodeData.tsvLine(): String {
    return "${code}\t$link\t$link\n"
}

fun List<CodeData>.tsv(): String {
    val sb = StringBuilder()
    sb.append("text\tqr\tnfc\n")
    this.forEach { code -> sb.append(code.tsvLine()) }
    return sb.toString()
}

fun CodeConfiguration.getOneSticker() = this.copy(amount = 1).generateCodes().firstOrNull()

fun CodeConfiguration.generateCodes(): List<CodeData> {
    val sb = StringBuilder()
    sb.append("text\tqr\tnfc\n")
    val selectedGroupStore = koinCtx.get<CurrentWorkspaceStore>()

    return (1..amount).map {
        val code =
            "${if (codePrefix.isNullOrBlank()) "" else "$codePrefix-"}${
                randomCode(
                    length = length,
                    charPool = charPool,
                )
            }"
        val ws = selectedGroupStore.current?.name
        val args =
            listOfNotNull(
                "id=${code.urlEncode()}",
                includeWorkspace.takeIf { it && !ws.isNullOrBlank() }?.let { "ws=$ws" },
                operation.takeIf { !it.isNullOrBlank() }?.let { "o=${it.urlEncode()}" },
                color?.let { "c=${color.name.urlEncode()}" },
                shape?.let { "s=${shape.name.urlEncode()}" },
                icon?.let { "i=${icon.name.urlEncode()}" },
                logintoken?.let { "logintoken=${logintoken.urlEncode()}" },
                tag.takeIf { !it.isNullOrBlank() }?.let { "t=${it.urlEncode()}" },
            )
                .takeIf { it.isNotEmpty() }
                ?.let { "#${it.joinToString("&")}" } ?: ""
        CodeData(code, link = "$urlPrefix$args", color, shape, icon, tag, logintoken)
    }
}

data class CodeConfiguration(
    val amount: Int = 4,
    val color: MarkerColor? = null,
    val shape: MarkerShape? = null,
    val icon: MarkerIcon? = null,
    val tag: String? = null,
    val logintoken: String? = null,
    val urlPrefix: String = "https://app.tryformation.com/",
    val charPool: String = defaultCharacters,
    val length: Int = 10,
    val codePrefix: String? = null,
    val operation: String? = null,
    val includeWorkspace: Boolean = false,
    val smallSticker: Boolean = false, // FIXME true doesn't quite work yet
    val scanToText: String = "TRACK"
)

class CodeConfigurationStore : RootStore<CodeConfiguration>(CodeConfiguration(), job = Job()) {
    val codeStore = storeOf<List<CodeData>>(listOf(), job)
    val busyStore = koinCtx.get<BusyStore>()

    val linkId = "export_qr_codes_link"

    val generate = handle { config ->
        codeStore.update(config.generateCodes())
        config
    }

    val download = handle { conf ->
        coroutineScope {
            launch {
                // wait a bit to give the browser the chance to update the href in response to the store
                // update
                // the href will contain the tsv we just downloaded in plaintext form ...
                delay(200)
                val e = document.createEvent("MouseEvents") as MouseEvent
                e.initEvent("click", bubbles = true, cancelable = true)
                // issue a click on the link to cause the download to happen
                document.getElementById(linkId)?.dispatchEvent(e)
                    ?: console.log("could not find link to click")
            }
        }
        conf
    }

    private suspend fun getHtml(
        codeConfig: CodeConfiguration,
        codes: List<CodeData>? = null
    ): String {
        val stickers = codes ?: codeStore.current
        val stickerHtml =
            stickers
                .map { sticker ->
                    val svg = urlToSvgQrCode(sticker.link)
                    """
                        <div class="sticker">
                            <div class="text-block">
                                <div class="row">
                                    <div class="logo">
                                        $logo
                                    </div>
                                    <div class="stack">
                                        <span style="font-size: 10px; font-weight: lighter;">
                                            Powered by
                                        </span>
                                        <span style="font-size: 14px; font-weight: bold;">
                                            F O R M A T I O N
                                        </span>
                                    </div>
                                </div>
                                <div class="row">
                                    <span style="font-size: 18px; font-weight: lighter;">
                                        SCAN TO
                                    </span>
                                </div>
                                <div class="row">
                                    <span style="font-size: 40px; font-weight: bolder;">
                                        ${codeConfig.scanToText}
                                    </span>
                                </div>
                            </div>
                            <div class="qr-block">
                              <div class="qr-wrapper">
                                $svg
                              </div>
                              <div class="row">
                                <span style="font-size: 12px; font-weight: lighter;">
                                    #${sticker.code}
                                </span>
                              </div>
                            </div>
                        </div>
                        """
                        .trimIndent()
                }
                .joinToString("\n")


        val html =
            """
            <html>
              <head>
                <title>FORMATION QR TRACKER</title>
                <style>



                  @media print {
                    @page {
                      size: portrait;
                    }
                  }

                  .sticker {
                    background-color: white;
                    font-family: sans-serif;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: space-between;
                  }
                  .text-block {
                    height: 40%;
                    width: 100%;
                    display: flex;
                    flex-direction: column;
                    justify-content: start;
                    align-items: center;
                  }
                  .qr-block {
                    height: 60%;
                    width: 100%;
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                    align-items: stretch;

                  }
                  .row {
                    width: 100%;
                    max-height: 100%;
                    display: flex;
                    flex-direction: row;
                    align-items: start;
                    justify-content: right;

                  }
                  .stack {
                    width: 100%;
                    display: flex;
                    flex-direction: column;
                    align-items: end;
                    justify-content: center;
                  }
                  .logo {
                    display: flex;
                    max-width: 100%;
                    min-width: 30%;
                  }
                  .qr-wrapper {
                    height: 100%
                    max-height: 100%;
                    margin-bottom: 1mm;
                  }
                  svg {
                    max-width: 100%;
                    max-height: 100%;
                    object-fit: contain;
                  }
                </style>
              </head>

              <body>
                $stickerHtml
              </body>
            </html>
            """
                .trimIndent()


//        val rows =
//            stickers
//                .map {
//                    val svg = urlToSvgQrCode(it.link)
//                    """<div style="break-inside: avoid;padding: 10px; border-bottom: 1px dashed black;">
//                    |<div style="border:2px solid grey;padding: 5px;border-radius: 15px;">
//                    |<center>
//                    |<div style="padding: 20px;">
//                    |$svg
//                    |</div>
//                    |</a>
//                    |</center>
//                    |</div>
//                    |</div>"""
//                        .trimMargin()
//                }
//                .joinToString("\n")

//        val html =
//            """
//            <html>
//                <head><title>FORMATION QR Codes</title></head>
//                <body>
//                    <div style="column-count: 2;column-rule: dashed 1px;">
//                    $rows
//                    </div>
//                </body>
//            </html>
//        """

        return html
    }

    private suspend fun getDemoTrackerPrint(config: CodeConfiguration): String {
        val stickers = codeStore.current
        val rows = stickers.map {
            """
               <div style="display: flex; align-items: center; justify-content: center; break-inside: avoid; padding: 10px; border-bottom: 1px dashed black;">
                    <div style="display: flex; align-items: center; justify-content: center; border:2px solid grey; padding:5px; border-radius:15px;">
                        ${getHtml(config, listOf(it))}
                    </div>
               </div>
            """.trimMargin()
        }.joinToString("\n")

        val html = """
                    <html>
                        <head><title>FORMATION QR Codes</title></head>
                        <body style="width: 100%; height: 100%;">
                            <div style="column-count: 2;column-rule: dashed 1px;">
                                $rows
                            </div>
                        </body>
                    </html>
                """.trimIndent()
        return html
    }

    val print = handle { codeConfig ->
        val iframe = document.createElement("iframe") as HTMLIFrameElement
        iframe.style.display = "none"
        document.body?.appendChild(iframe)
        val pri = iframe.contentWindow
        pri?.let {
            pri.document.open()
            pri.document.write(getDemoTrackerPrint(codeConfig))
            pri.document.close()
            pri.focus()
            pri.onafterprint = { document.body?.removeChild(iframe) }
            pri.print()
        }
        codeConfig
    }

    val openTab = handle { config ->
        val codes = codeStore.current
        busyStore.handleApiCall(
            suspend {
                val rows =
                    codes
                        .map {
                            val svg = urlToSvgQrCode(it.link)
                            """<div style="break-inside: avoid;padding: 10px; border-bottom: 1px dashed black;">
                    |<div style="border:2px solid grey;padding: 5px;border-radius: 15px;">
                    |<center>
                    |${it.code}<br><a download="${it.code}.svg" href="data:image/svg;base64,${
                                svg.toByteArray().encodeBase64()
                            }">
                    |<div style="padding: 20px;">
                    |$svg
                    |</div>
                    |</a>
                    |</center>
                    |</div>
                    |</div>"""
                                .trimMargin()
                        }
                        .joinToString("\n")

                val html =
                    """
            <html>
                <head><title>FORMATION QR Codes</title></head>
                <body>
                    <div style="column-count: 4;column-rule: dashed 1px;">
                    $rows
                    </div>
                </body>
            </html>
        """
                        .trimIndent()

                //            val rows = codes.map {
                //                val svg = toSvgQrCode(it.link)
                //                """
                //                    <div style="display: flex; align-items: center;
                // justify-content: center; break-inside: avoid; padding: 10px; border-bottom: 1px
                // dashed black;">
                //                        <div style="display: flex; align-items: center;
                // justify-content: center; border:2px solid grey;padding: 5px; border-radius:
                // 15px;">
                //                            <a download="${it.code}.svg"
                // href="data:image/svg;base64, ${
                //                    svg.toByteArray().encodeBase64()
                //                }">
                //                                ${getHtmlForSingleCode(config, it)}
                //                            </a>
                //                        </div>
                //                    </div>
                //                """.trimMargin()
                //            }.joinToString("\n")
                //
                //            val html = """
                //            <html>
                //                <head><title>FORMATION QR Codes</title></head>
                //                <body style="width: 100%; height: 100%;">
                //                    <div style="width: 100%; height: 100%; display: flex;
                // flex-wrap: wrap;">
                //                        $rows
                //                    </div>
                //                </body>
                //            </html>
                //        """.trimIndent()

                val w = window.open("about:blank")!!
                w.document.write(html)

                Result.success("")
            },
        )

        config
    }
}

fun String.base64() = btoa(this)
